import MaxFirmwareUpgradeRetries from "./MaxFirmwareUpgradeRetries.js";
import FirmwareUpgradeStrategy from "./FirmwareUpgradeStrategy.js";
import FirmwareComponentTypes from "./FirmwareComponentTypes.js";
import ProjectId from "./ProjectId.js";
import Metadata from "./Metadata.js";
import Options from "./Options.js";
import Name from "./Name.js";
import Id from "./Id.js";
import Concurrency from "./Concurrency.js";
import DefaultLoadBalancerEnabled from "./DefaultLoadBalancerEnabled.js";
import DefaultReleaseFirmware from "./DefaultReleaseFirmware.js";
import DefaultUpgradeWindowsEnabled from "./DefaultUpgradeWindowsEnabled.js";
import FirmwareUpgradeMaxRetries from "./FirmwareUpgradeMaxRetries.js";
import FirmwareUpgradeStrategyType from "./FirmwareUpgradeStrategyType.js";
import RemoveStaleUpgradingDevices from "./RemoveStaleUpgradingDevices.js";
import SameFirmwareIsError from "./SameFirmwareIsError.js";
import StaleDeviceTimeout from "./StaleDeviceTimeout.js";
import GroupBlueprintId from "./GroupBlueprintId.js";
import GroupOperationHoursPath from "./GroupOperationHoursPath.js";
import ImagineSystemId from "./ImagineSystemId.js";
import SubGroupName from "./SubGroupName.js";
import WriteToGroup from "./WriteToGroup.js";
function install(molten) {
  molten.addPlugin('Attribute', Id);
  molten.addPlugin('Attribute', ProjectId);
  molten.addPlugin('Attribute', Name);
  molten.addPlugin('Attribute', FirmwareComponentTypes);
  molten.addPlugin('Attribute', FirmwareUpgradeStrategy);
  molten.addPlugin('Attribute', MaxFirmwareUpgradeRetries);
  molten.addPlugin('Attribute', Metadata);
  molten.addPlugin('Attribute', Options);
  molten.addPlugin('Attribute', Concurrency);
  molten.addPlugin('Attribute', DefaultLoadBalancerEnabled);
  molten.addPlugin('Attribute', DefaultReleaseFirmware);
  molten.addPlugin('Attribute', DefaultUpgradeWindowsEnabled);
  molten.addPlugin('Attribute', FirmwareUpgradeMaxRetries);
  molten.addPlugin('Attribute', FirmwareUpgradeStrategyType);
  molten.addPlugin('Attribute', RemoveStaleUpgradingDevices);
  molten.addPlugin('Attribute', SameFirmwareIsError);
  molten.addPlugin('Attribute', StaleDeviceTimeout);
  molten.addPlugin('Attribute', GroupBlueprintId);
  molten.addPlugin('Attribute', GroupOperationHoursPath);
  molten.addPlugin('Attribute', ImagineSystemId);
  molten.addPlugin('Attribute', SubGroupName);
  molten.addPlugin('Attribute', WriteToGroup);
}
export default {
  install
};